import { BackTraceType } from "@/types/summary";

// 完全开放，不限制任何字符
export const speakerNameLimitPattern = /(?!)/g;

// 原来的限制：只允许中英文、数字、空格
// export const speakerNameLimitPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/g;

export const recordTitleMaxLen = 24;

// role序号只能用数字标识，为了不与声纹列表中现存role相同，由前端在录制中/详情中新建的role由5000开始倒序
export const maxRecordRoleId = 5000;

export const meetingContentFormatPattern = /^\d+\.\s*/;

export enum MeetingSummaryEvent {
  SUMMARY = "SUMMARY",
  TODO = "TODO",
}
export const SummaryBackTraceArr: { [key: string]: MeetingSummaryEvent } = {
  contentBackTrace: MeetingSummaryEvent.SUMMARY,
  todoBackTrace: MeetingSummaryEvent.TODO,
};

export const BackTraceKeyMap: { [key: string]: BackTraceType } = {
  todo: 'todoBackTrace',
};


export enum Tab {
  // 纪要
  summary = "summary",
  // 章节
  smartChapters = "smart-chapters",
  // 发言人总结
  speakerSummary = "speaker-summary",
}

export const tabList = [
  {
    id: Tab.summary,
    value: "纪要",
  },
  {
    id: Tab.smartChapters,
    value: "章节",
  },
  {
    id: Tab.speakerSummary,
    value: "发言人观点",
  },
];

export enum ExportType {
  exportSrcDoc = "exportSrcDoc",
  exportSummary = "exportSummary",
  exportAudio = "exportAudio",
  exportSpeechDraft = "exportSpeechDraft",
}

export const exportTypeNameMap = {
  [ExportType.exportSrcDoc]: "原文",
  [ExportType.exportSummary]: "智能总结",
  [ExportType.exportAudio]: "音频",
  [ExportType.exportSpeechDraft]: "发言稿",
};

export enum SummaryStreamType {
  meetingSummary = "meetingSummary",
  content = "content",
  todo = "todo",
}
export enum DetailErrorType {
  deleted = 40002103,
  ERR_NETWORK = "ERR_NETWORK",
}

export const PLAYED_DOC_ITEM_CLASSNAME = "played-doc-item";
export const PLAYING_DOC_ITEM_CLASSNAME = "playing-doc-item";
export const SRC_CONTENT_CLASSNAME = "src-content";

export const SUMMARY_TEXTAREA_ID = "summary-textarea";
export const TODO_TEXTAREA_ID_PREFIX = "todo-textarea-";

export const avatarBgs = [
  "linear-gradient(179.79deg, #4981F2 -12.23%, rgba(73, 129, 242, 0.5) 99.85%)",
  "linear-gradient(180deg, #36CFC9 8.33%, rgba(54, 207, 201, 0.5) 104.17%)",
  "linear-gradient(180deg, #FFC53D 8.33%, rgba(255, 197, 61, 0.5) 104.17%)",
  "linear-gradient(180deg, #FF5319 -31.25%, rgba(255, 83, 25, 0.5) 104.17%)",
  "linear-gradient(180deg, #5856D6 -31.25%, rgba(88, 86, 214, 0.5) 104.17%)",
  "linear-gradient(180deg, #5AC8FA 0%, rgba(90, 200, 250, 0.5) 104.17%)",
  "linear-gradient(180deg, #34C759 0%, rgba(52, 199, 89, 0.5) 104.17%)",
];
